import React from 'react';
import styles from './progress.module.scss';
import classNames from 'classnames/bind';

interface InputProps {
  danger?: boolean;
  deepWarning?: boolean;
  warning?: boolean;
  // 藍色（$theme1）。預設色是綠；既有的 danger / deepWarning / warning 都沒動。
  theme1?: boolean;
  progress: number;
}

const Progress: React.FunctionComponent<InputProps> = (props) => {

  const cssClassNames = classNames.bind(styles);

  const progressClass = cssClassNames('progress', {
    danger: props.danger,
    deepWarning: props.deepWarning,
    warning: props.warning,
    theme1: props.theme1,
    // 既有的 notStart 判斷式一字未改：theme1 與它同時掛上時由 scss 的來源順序決勝。
    notStart: props.progress === 0 && (!props.danger && !props.deepWarning && !props.warning)
  });

  return (
    <div className={progressClass}>
      <div
        style={{
          width: `${Math.min(props.progress * 100, 100)}%`
        }}
      />
    </div>
  );
};

export default Progress;
